import o from "react";
import { componentName as e } from "../../../utils/bem/index.js";
function t() {
  var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
    d = t.size,
    r = void 0 === d ? 6 : d,
    a = t.color,
    l = t.className;
  return t.dark && (a = "gray"), t.small && (r = 2), o.createElement("div", {
    className: e("dot-loader", l)
  }, o.createElement("div", {
    style: {
      width: r,
      height: r,
      backgroundColor: a,
      color: a
    },
    className: "dot-loader--dot dot1"
  }), o.createElement("div", {
    style: {
      width: r,
      height: r,
      backgroundColor: a,
      color: a
    },
    className: "dot-loader--dot dot2"
  }), o.createElement("div", {
    style: {
      width: r,
      height: r,
      backgroundColor: a,
      color: a
    },
    className: "dot-loader--dot dot3"
  }));
}
t.displayName = "DotLoader";
export { t as DotLoader };